import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

/**
 * A placeholder page for features that are still in development.
 */
export default function ComingSoon({
    title = 'Coming Soon',
    message = 'This feature is currently under development.',
    icon = '🚧',
    showBackButton = true,
    backPath = '/',
    backLabel = 'Back to Home',
}) {
    const location = useLocation();

    return (
        <section className="coming-soon-section min-vh-100 d-flex align-items-center justify-content-center bg-primary">
            <Container>
                <Row className="justify-content-center">
                    <Col xs={11} md={8} lg={6} className="text-center">
                        <div className="coming-soon-icon mb-4">{icon}</div>
                        <h1 className="display-4 fw-bold mb-4 text-warning">
                            {title}
                        </h1>
                        <p className="lead mb-4 text-white opacity-75">
                            {message}
                        </p>
                        <p className="fs-4 mb-5 text-white opacity-50">
                            Requested path:{' '}
                            <code className="text-white">
                                {location.pathname}
                            </code>
                        </p>
                        {showBackButton && (
                            <Button
                                as={Link}
                                to={backPath}
                                size="lg"
                                variant="outline-warning"
                                className="fw-semibold px-4 rounded-pill"
                            >
                                {backLabel}
                            </Button>
                        )}
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

ComingSoon.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    icon: PropTypes.string,
    showBackButton: PropTypes.bool,
    backPath: PropTypes.string,
    backLabel: PropTypes.string,
};
